import React from 'react';
import Icon from '../../../components/AppIcon';
import EmailForm from './EmailForm';

const ValueProposition = ({ email, onEmailChange, emailError, onValidate }) => {
  const benefits = [
    {
      icon: "Target",
      title: "Your Pattern",
      description: "Identify the survival identity sabotaging your growth"
    },
    {
      icon: "TrendingUp",
      title: "The Mechanism",
      description: "Understand the internal conflict driving your behavior"
    },
    {
      icon: "BookOpen",
      title: "Install New Patterns",
      description: "Specific strategies to dissolve the False Self"
    }
  ];

  return (
    <div className="w-full max-w-2xl mx-auto mb-10 md:mb-12">
      <div className="text-center mb-8 md:mb-10">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-white mb-4 uppercase tracking-tight">
          Assessment Complete
        </h1>
        <p className="text-lg md:text-xl text-brand-steel max-w-xl mx-auto mb-8">
          Enter your email to receive your personalized False Self analysis.
        </p>

        {/* Get Your Results Section - Moved Here */}
        <div className="bg-brand-charcoal rounded-lg p-8 md:p-10 border border-brand-slate max-w-2xl mx-auto mb-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-white mb-4 uppercase tracking-tight">
              Get Your Results
            </h2>
            <p className="text-base md:text-lg text-brand-steel">
              We'll send your personalized analysis. No spam. No bullshit.
            </p>
          </div>

          <div>
            <EmailForm
              email={email}
              onEmailChange={onEmailChange}
              error={emailError}
              onValidate={onValidate}
            />

            <div className="mt-8 pt-6 border-t border-brand-slate">
              <div className="flex items-center justify-center gap-2 text-sm text-brand-steel">
                <span>Trusted by 10,000+ men</span>
                <span className="text-brand-gold">•</span>
                <span>100% secure & confidential</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {benefits?.map((benefit, index) => (
          <div 
            key={index}
            className="flex flex-col items-center text-center p-6 bg-brand-charcoal rounded-lg border border-brand-slate"
          >
            <div className="w-14 h-14 rounded-md bg-brand-gold/10 flex items-center justify-center mb-4">
              <Icon name={benefit?.icon} size={24} color="#C9A227" />
            </div>
            <h3 className="text-base md:text-lg font-bold text-brand-white mb-2 uppercase tracking-wide">
              {benefit?.title}
            </h3>
            <p className="text-sm md:text-base text-brand-steel leading-relaxed">
              {benefit?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValueProposition;